import { render } from "./PeriodoQuestionario.vue?vue&type=template&id=284afb81"
import script from "./PeriodoQuestionario.vue?vue&type=script&lang=js"
export * from "./PeriodoQuestionario.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__